import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resolveSeoData, applySeoHead } from '@/lib/seo';
import { applyWebSiteJsonLd, applyPageJsonLd } from '@/lib/jsonLd';

export default function SeoManager() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const lang = i18n.language || 'en';

  useEffect(() => {
    applyWebSiteJsonLd();
  }, []);

  useEffect(() => {
    const seo = resolveSeoData(location.pathname, lang);
    applySeoHead(seo, lang);
    applyPageJsonLd(seo, lang);
  }, [location.pathname, lang]);

  return null;
}